import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation ChangeTeam($teamId: ID!) {
  changeTeam(teamId: $teamId)
}`;

function changeTeam(teamId) {
  return apollo.client.mutate({
    mutation,
    variables: {
      teamId,
    },
  }).then((res) => res.data.changeTeam);
}

export default changeTeam;
